import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { virtualMachinesLiteByIdSelector } from 'openstack/components/vms/selectors'
import { networksByIdSelector } from '../selectors'

// Mirrors the Allocation column's render: blank when unassigned, otherwise the VM name
// or, for a bare port, the port name/id
const getAllocationLabel = (floatingIp, allocation): string => {
  if (!floatingIp?.fixed_ip_address) {
    return ''
  }
  return allocation
    ? `VM: ${allocation?.name ?? ''}`
    : `Port: ${floatingIp?.port_details?.name || floatingIp?.port_id || ''}`
}

export const floatingIpsSelector = createSharedSelector(
  getDataSelector<DataKeys.FloatingIps>(DataKeys.FloatingIps),
  virtualMachinesLiteByIdSelector,
  networksByIdSelector,
  (floatingIps, vmsLiteById, networksById) => {
    return floatingIps.map((floatingIp) => {
      const allocation = vmsLiteById?.(floatingIp?.port_details?.device_id)
      return {
        ...floatingIp,
        allocation,
        // Plain-text version of the Allocation column, used for sorting and search
        allocationLabel: getAllocationLabel(floatingIp, allocation),
        network: networksById?.[floatingIp?.floating_network_id],
      }
    })
  },
)

export const floatingIpsByDeviceIdSelector = createSharedSelector(
  floatingIpsSelector,
  (floatingIps) =>
    floatingIps.reduce((accum, floatingIp) => {
      return floatingIp?.port_details?.device_id
        ? accum[floatingIp.port_details.device_id]
          ? {
              ...accum,
              [floatingIp.port_details.device_id]: [
                ...accum[floatingIp.port_details.device_id],
                floatingIp,
              ],
            }
          : {
              ...accum,
              [floatingIp.port_details.device_id]: [floatingIp],
            }
        : accum
    }, {}),
)
